<template>
  <div>
    <Head :title="title" />
    <trashed-message v-if="user.deleted_at" class="mb-6" @restore="restore"> This user has been deleted. </trashed-message>
    <div class="max-w-full bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">

            <text-input-editable v-model="form.first_name" :error="form.errors.first_name" :value="form.first_name" class="pb-8 pr-6 w-full lg:w-1/3" :label="__('First name')" :editable="true" />
            <text-input-editable v-model="form.last_name" :error="form.errors.last_name" :value="form.last_name" class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Last name')" :editable="true" />
            <text-input-editable v-model="form.email" :error="form.errors.email" :value="form.email" class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Email')" :editable="true" />
            <text-input-editable v-model="form.username" :value="form.username" :error="form.errors.username" class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Username')" :editable="true" />
            <text-input-editable v-model="form.city" :value="form.city" :error="form.errors.city" class="pb-8 pr-6 w-full lg:w-1/3" :label="__('City')" :editable="true" />
            <select-edit-input placeholder="Select country" :items="countries" :value="user.country" v-model="form.country_id" :error="form.errors.country_id" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Country')" :editable="true" />
            <text-input-editable v-model="form.phone" :value="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Phone')" :editable="true" />
            <text-input-editable v-model="form.address" :value="form.address" :error="form.errors.address" class="pb-8 pr-6 w-full lg:w-2/3" :label="__('Address')" :editable="true" />
            <text-input-editable v-model="form.password" value="*********" :error="form.errors.password" class="pb-8 pr-6 w-full lg:w-1/3" type="password" autocomplete="new-password" :label="__('Password')" :editable="true" />
            <select-edit-input v-if="user.id !== auth.user.id" placeholder="Select role" :items="roles" :value="user.role" v-model="form.role_id" :error="form.errors.role_id" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Role')" :editable="true" />

          <file-input v-model="form.photo" :error="form.errors.photo" class="pb-8 pr-6 w-full lg:w-1/3" type="file" accept="image/*" label="Photo" />
            <div class="w-full lg:w-1/3 flex items-center justify-start"><img v-if="user.photo_path" class="block mb-2 w-8 h-8 rounded-full" :src="user.photo_path" /></div>
            <label class="pb-8 pr-6 w-full select-none flex items-center" for="remember">
                <input id="remember" :checked="user.available" class="mr-1" type="checkbox" @change="changeAvailability($event)" />
                <strong>{{ __('Available for schedule') }}</strong> ({{ __('Doing enable it, the user will be visible on the public appointment list.') }})
            </label>
        </div>

        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="user.id !== auth.user.id && user_access.user.delete && !user.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">
            {{ __('Delete User') }} </button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">{{ __('Update User') }} </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextInputEditable from '@/Shared/TextInputEditable'
import SelectEditInput from '@/Shared/SelectEditInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
      TextInputEditable,
      SelectEditInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    user: Object,
    auth: Object,
    countries: Array,
    roles: Array,
    cities: Array,
    title: String,
  },
  remember: 'form',
  data() {
    return {
        user_access: this.$page.props.auth.user.access,
      form: this.$inertia.form({
        _method: 'put',
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        phone: this.user.phone,
        city: this.user.city,
        address: this.user.address,
        country_id: this.user.country_id,
        username: this.user.username,
        password: '',
        role: this.user.role,
        role_id: this.user.role_id,
          available: this.user.available,
        photo: null
      }),
    }
  },
  created() {
    // this.setDefaultValue(this.countries, 'country_id', 'United States')
  },
  methods: {
      changeAvailability(e){
          this.form.available = e.currentTarget.checked
      },
    setDefaultValue(arr, key, value){
      const find = arr.find(i=>i.name.match(new RegExp(value + ".*")))
      if(find){
        this.form[key] = find['id']
      }
    },
    update() {
      this.form.post(this.route('users.update', this.user.id), {
        onSuccess: () => this.form.reset('password', 'photo'),
      })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this user?')) {
        this.$inertia.delete(route('users.destroy', this.user.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this user?')) {
        this.$inertia.put(route('users.restore', this.user.id))
      }
    },
  },
}
</script>
